export default __webpack_public_path__ + "static/media/iden.132a5d34.png";